import { DataTable } from "./DataTable";
import StaticTable from "./StaticTable";

export default function ReceivingTable({ data, columns, title, searchKeys }) {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-3">{title}</h2>
      <StaticTable
        columns={columns}
        data={data}
        searchKeys={searchKeys}
        pinRowPredicate={(row) => row[searchKeys] === "Grand Total"}
        initialSort={{ key: searchKeys, dir: "desc" }}
        pageSizeOptions={[5, 10, 25, 50]}
      />
    </div>
  );
}
